module.exports = __webpack_public_path__ + "static/media/mockup.86794ed6.png";